export default {
    boxes: [
        {
            id: 1,
            name: 'Estados Unidos',
            email: 'gmata@redvolutionlatam.com',
            address: '2000 Ponce de León, BLVD STE 600, CORAL GABLES, FL 33134',
            phone: '786738836',
            active: false,
            class: 'estados'
        },
        {
            id: 2,
            name: 'México',
            email: 'angelica_perez@cosmic.com.mx',
            address: ' Eje 8 Sur (Av. Popocatépetl) 257, Benito Juarez, General Anaya Ciudad de México, CDMX ',
            phone: '41517700 Ext 6405',
            active: false,
            class: 'mexico'
        },
        {
            id: 3,
            name: 'Guatemala',
            email: 'mmoran@redvolutionlatam.com',
            address: '3RA CALLE A 4-24 INTERIOR, ZONA 10  C.P.1010 <br>GUATEMALA, GT"',
            phone: '+502 32235219',
            active: false,
            class: 'guatemala'
        },
        {
            id: 4,
            name: 'República Dominicana',
            email: 'idebord@redvolutionlatam.com',
            address: '"FEDERICO GERALDINO 50 401, ENSANCHE PIANTINI, <br>SANTO DOMINGO, REPUBLICA DOMINICANA"',
            phone: '+1 (829) 648-8032',
            active: false,
            class: 'republica'
        },
        {
            id: 5,
            name: 'El Salvador',
            email: 'amgarcia@redvolutionlatam.com',
            address: '"13 CALLE PONIENTE # 834 COLONIA ESCALÓN, <br>SAN SALVADOR, ESV',
            phone: '+503 79106214',
            active: false,
            class: 'salvador'
        },
        {
            id: 6,
            name: 'Honduras',
            email: 'scasco@redvolutionlatam.com',
            address: 'COL. TRES CAMINOS, BLOQUE L, CALLE DIAGONAL, CASA 192 <br>TEGUCIGALPA, HONDURAS.',
            phone: '+504 9607-6700',
            active: false,
            class: 'honduras'
        },
        {
            id: 7,
            name: 'Nicaragua',
            email: 'dcastillo@redvolutionlatam.com',
            address: 'SEMAFOROS DEL TERRAZA (VILLA FONTANA) 1 CUADRA NORTE (LAGO), 1 CUDARA ESTE, 10 VS. NORTE, MANO DERECHA VERA ENTRADA Y LA AGUJA. SEGUNDA CASA MANO DERECHA. MANAGUA, NI',
            phone: '+505 84544292',
            active: false,
            class: 'nicaragua'
        },
        {
            id: 8,
            name: 'Costa Rica',
            email: 'jvargas@redvolutionlatam.com',
            address: 'SABANA OESTE A 100 MTS OESTE EMBAJADA ALEMANA, <br> PLANTA BAJASAN JOSÉ, COSTA RICA',
            phone: '+503 7920 6302',
            active: false,
            class: 'rica'
        },
        {
            id: 9,
            name: 'Panamá',
            email: 'apurcait@redvolutionlatam.com',
            address: 'BETHANIA, DETRÁS FARMACIAS METRO, <br>1ER CALLE A MANO DERECHA. CASA #44 PANAMÁ, PANAMÁ',
            phone: '+507 6266-8791',
            active: false,
            class: 'panama'
        },
        {
            id: 10,
            name: 'Colombia',
            email: 'hector.becerra@visionymarketing.com.co',
            address: 'CALLE 101 # 45A - 82. LAS MARGARITAS',
            phone: 'Héctor Manuel Becerra - Cel. +57 3204903402 <br>Fijo. +57 (1) 6012209 ext. 10124',
            active: false,
            class: 'colombia'
        },
        {
            id: 11,
            name: 'Perú',
            email: 'mportal@redvolutionlatam.com',
            address: 'Roca y Boloña 316 Miraflores',
            phone: '+ 51 979900715',
            active: false,
            class: 'peru'
        },
        {
            id: 12,
            name: 'Puerto Rico',
            email: 'gmata@redvolutionlatam.com',
            address: 'Urbanización la Merced 558 Cabo Alverio San Juan, Puerto Rico 00918',
            phone: '+1 (939) 405-9252',
            active: false,
            class: 'puerto'
        },
    ]
}


// WEBPACK FOOTER //
// ./resources/assets/vue/components/coverage/BoxesData.js